import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing24, spacing8 } from 'approot/shared/styles/spacing.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { grey9 } from 'approot/shared/styles/colours.style';

export const LessonMaterialButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(spacing8)};
  padding-bottom: ${rem(spacing24)};
`;

export const LessonMaterialButton = styled(SecondaryButton).attrs({
  $isSmall: true,
})`
  border-radius: ${rem(40)};
  height: auto;
  padding-top: ${rem(spacing8)};
  padding-bottom: ${rem(spacing8)};
`;

export const LessonMaterialItem = styled.div`
  ${font16}
  color: ${grey9};
`;
